import { createForm } from '@ecom-zform/core';
import { useRef } from 'react';
/**
 * 用来创建表单，返回根表单节点。设置 `initialValue` 后会自己将 `value` 设置为 `initialValue`。
 * @param formState
 * @param options
 */
export function useCreateForm(formState, options) {
    if (formState === void 0) { formState = {}; }
    if (options === void 0) { options = {}; }
    var form = useRef();
    if (!form.current) {
        form.current = createForm(formState, options);
    }
    return form.current;
}
